<template>
	<div>
        <div class="list-content">
              <div>
                <img class="image_div" :src="itemChild.bookLogoUrl" mode="" />
                <span class="book_name">{{ itemChild.bookName }}</span>
                <!-- <span class="sort" v-if="itemChild.category">{{
            itemChild.category.split(",")[0]
          }}</span> -->
              </div>
          </div>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		name: 'three_conpontent',
		props: {
            itemChild:{
				type: Object,
				default: {
                }
            }
		},
		data() {
			return {
			};
		},
		watch: {
			// current(val) {
			// 	if (val !== this.currentIndex) {
			// 		this.currentIndex = val;
			// 	}
			// }
		},
		methods: {
			
		},
		created() {
		}
	};
</script>

<style  scoped>
.image_div {
  display: block;
  width: 70px;
  height: 92px;
  /* width: 1.9rem;
   height: 2.52rem; */
  border-radius: 6px;
}

.book_name {
  font-size: 14px;
  color: #333333;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  width: 70px;
  margin-top: 12px;
  height:40px;
  line-height: 20px;
  font-weight: bold;
}
.sort{
  background-color: rgb(253, 245, 233);
  border-radius: 2px;
  font-size: 12px;
  padding: 0px 5px;
  color: #f09b28;
  margin-top: 5px;
  line-height: 18px;
  display:inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/book_item/four_compontent.vue